/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ContractRequirementType;

(function (ContractRequirementType) {
  ContractRequirementType["COVERAGE"] = "coverage";
  ContractRequirementType["PERIOD"] = "period";
})(ContractRequirementType || (ContractRequirementType = {}));